import { FETCH_SMS_SETTINGS, UPDATE_SMS_SETTINGS } from '../actions/constants';

const initialState = {
    settings: null,
    loading: false,
    error: null
};

const smsSettings = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SMS_SETTINGS:
            return {
                ...state,
                settings: action.payload,
                loading: false,
                error: null
            };
        case UPDATE_SMS_SETTINGS:
            return {
                ...state,
                settings: action.payload,
                loading: false,
                error: null
            };
        default:
            return state;
    }
};

export default smsSettings;
